module.exports = __webpack_public_path__ + "static/img/img_04.d9fe64df.png";